export default __webpack_public_path__ + "static/media/audio-file.5e5200f5.svg";